module.exports = __webpack_public_path__ + "static/rpp-192db47c0a35fdc1a7a4205c299ee617.png";